export const COVER_AND_REPORT_LAYOUT = 'Cover And Report';
export const QC_LAYOUT = 'QC';
export const SUMMARY_LAYOUT = 'Summary';
export const REPORT_ONLY_LAYOUT = 'Report Only';
export const OFFICIAL_REPORT = 'Official';
export const UNOFFICIAL_REPORT = 'OfficialInvalid';

export const STANDARD_TEMPLATE = 'Standard';
export const RESULTS_TEMPLATE = 'Based On Result';

export const WHO_REFERENCE_LINE = 'WHO';
export const EPA_REFERENCE_LINE = 'EPA';
export const CUSTOM_REFERENCE_LINE = 'Custom';
export const NONE_REFERENCE_LINE = 'None';

export const REPORT_TYPES = {
  STANDARD: 'Standard',
  HIGH: 'High',
  MODERATE: 'Moderate',
  LOW: 'Low',
};

export const STANDARD_SUB_REPORT_TYPES = [REPORT_TYPES.STANDARD];

// Prefix 'Basic - ' is used only on UI to display old layout reports
export const REPORT_DISPLAY_NAMES = {
  [OFFICIAL_REPORT]: 'Official Report',
  [UNOFFICIAL_REPORT]: 'Invalid Report',
  [COVER_AND_REPORT_LAYOUT]: 'Basic - Cover and Report',
  [REPORT_ONLY_LAYOUT]: 'Basic - Report Only',
  [SUMMARY_LAYOUT]: 'Basic - Summary',
  [QC_LAYOUT]: 'Basic - Quality Control Report',
};

export const REPORT_DESCRIPTIONS = {
  [COVER_AND_REPORT_LAYOUT]:
    'The report begins with a cover letter and provides all test details including graph and hourly interval\n' +
    'readings.',
  [REPORT_ONLY_LAYOUT]: 'The report provides all test details including graph and hourly interval readings.',
  [SUMMARY_LAYOUT]: 'The report provides test results but does not provide a graph or hourly interval readings.',
  [QC_LAYOUT]:
    'The report is run for a specific CRM. System will query the database for all tests for the given CRM serial\n' +
    'number where QC was marked as TRUE within the test details. Report will display all QC tests for that\n' +
    'device.',
};

export const TITLE_BASIC_LAYOUTS_BLOCK = 'Basic Report Layouts';
export const DESCRIPTIONS_BASIC_LAYOUTS_BLOCK =
  'Basic Report Layouts DO NOT meet ' +
  'the ANSI/AARST MAH 2019 Protocol for Conducting Measurements of Radon and Radon Decay Products in Homes. ';

export const TITLE_OFFICIAL_REPORTS_BLOCK = 'Official Reports';
export const DESCRIPTIONS_OFFICIAL_REPORTS_BLOCK = [
  'All Official Report Layouts meet the ANSI/AARST MAN 2019 Protocol for\n' +
    'Conducting Measurements of Radon and Radon Decay Products in Homes. ',
  ' and any relevant state-specific requirements for the state for which the Report Layout is named.',
];

export default [
  REPORT_DISPLAY_NAMES[OFFICIAL_REPORT],
  REPORT_DISPLAY_NAMES[UNOFFICIAL_REPORT],
  REPORT_DISPLAY_NAMES[COVER_AND_REPORT_LAYOUT],
  REPORT_DISPLAY_NAMES[REPORT_ONLY_LAYOUT],
  REPORT_DISPLAY_NAMES[SUMMARY_LAYOUT],
  // REPORT_DISPLAY_NAMES[QC_LAYOUT],
];



// WEBPACK FOOTER //
// src/constants/reportLayouts.js